import { render } from "./SettingsServices.vue?vue&type=template&id=01762a50&scoped=true"
import script from "./SettingsServices.vue?vue&type=script&lang=js"
export * from "./SettingsServices.vue?vue&type=script&lang=js"

import "./SettingsServices.vue?vue&type=style&index=0&id=01762a50&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01762a50"]])

export default __exports__